export const fillVariablesInJson = (
  json: string,
  variables: {key?: string; value?: string}[][],
) => {
  try {
    let parsedBody = json;

    variables.forEach((variable: {key: string; value: string}[]) => {
      const variableKey = variable.find(v => v.key === "key")?.value || "";
      const variableValue = variable.find(v => v.key === "value")?.value || "";

      parsedBody = parsedBody.replace(`<${variableKey}>`, variableValue);
    });

    return parsedBody;
  } catch {
    return json;
  }
};

export const formatJsonValue = (value: string): string => {
  try {
    // First try to parse the JSON
    const parsed = JSON.parse(value);
    // Then stringify with indentation (2 spaces)
    return JSON.stringify(parsed, null, 2);
  } catch {
    return value;
  }
};

export const isValidJson = (value: string) => {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
};
